import type React from "react";
import { useState } from "react";
import {
	Table,
	TableBody,
	TableCell,
	TableHead,
	TableHeader,
	TableRow,
} from "@/components/ui/table";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { useUsers } from "@/hooks/useUsers"; // 実装が必要

const UserManagementPage: React.FC = () => {
	const [searchQuery, setSearchQuery] = useState("");
	const { users, loading, error } = useUsers(); // カスタムフックを実装する必要があります

	const filteredUsers = users?.filter(
		(user) =>
			user.username.toLowerCase().includes(searchQuery.toLowerCase()) ||
			user.email.toLowerCase().includes(searchQuery.toLowerCase()),
	);

	return (
		<div className="space-y-6">
			<div className="flex justify-between items-center">
				<h1 className="text-3xl font-bold">ユーザー管理</h1>
				<Input
					className="max-w-sm"
					placeholder="ユーザーを検索..."
					value={searchQuery}
					onChange={(e) => setSearchQuery(e.target.value)}
				/>
			</div>

			{loading ? (
				<div>読み込み中...</div>
			) : error ? (
				<div className="text-red-500">エラーが発生しました: {error}</div>
			) : (
				<Table>
					<TableHeader>
						<TableRow>
							<TableHead>ユーザー名</TableHead>
							<TableHead>メールアドレス</TableHead>
							<TableHead>権限</TableHead>
							<TableHead>ステータス</TableHead>
							<TableHead>登録日</TableHead>
							<TableHead>アクション</TableHead>
						</TableRow>
					</TableHeader>
					<TableBody>
						{filteredUsers?.map((user) => (
							<TableRow key={user.id}>
								<TableCell>{user.username}</TableCell>
								<TableCell>{user.email}</TableCell>
								<TableCell>{user.role}</TableCell>
								<TableCell>
									{user.isActive ? (
										<span className="text-green-500">有効</span>
									) : (
										<span className="text-red-500">無効</span>
									)}
								</TableCell>
								<TableCell>
									{new Date(user.createdAt).toLocaleDateString()}
								</TableCell>
								<TableCell>
									<Button variant="outline" size="sm">
										編集
									</Button>
								</TableCell>
							</TableRow>
						))}
					</TableBody>
				</Table>
			)}
		</div>
	);
};

export default UserManagementPage;
